import { render, staticRenderFns } from "./Chart3.vue?vue&type=template&id=5d771a6b&"
import script from "./Chart3.vue?vue&type=script&lang=ts&"
export * from "./Chart3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports